export const hasAccess = (requiredProduct, plan) => {
  if (!requiredProduct) {
    return true;
  }

  return requiredProduct.some(product => {
    // treat revealAnnual and vectorPlatform in plan as target
    if (product === 'target') {
      return plan?.target || plan?.revealAnnual || plan?.vectorPlatform;
    }

    return plan?.[product];
  });
};
